export const MenuIdFilters = 'FILTERS' as const;
